import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=5b41dea1&"
import script from "./TaskAssignment.vue?vue&type=script&lang=js&"
export * from "./TaskAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports